import React from 'react';
import './ChallengeButton.scss'

const ChallengeButton = (props) => {
    const {successBtn, detailBtn, secBtn, disabledBtn, btnTitle, onBtnClick, disabled} = props;
    const success = successBtn ? 'successBtn' :'';
    const detail = detailBtn ? 'detailBtn' :'';
    const secondary = secBtn ? 'secondaryBtn':'';
    const disabledButton = disabledBtn ? 'disabledBtn' : '';
    return (
        <div className={`challenge-btn-container ${success} ${detail} ${secondary} ${disabledButton}`} onClick={!disabled ? onBtnClick : undefined}>
            <div className='challenge-btn-container-title'>{btnTitle}</div>
        </div>
    )
}

export default ChallengeButton